import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { ConversationType } from '@/types/conversation.types';
import type { ParticipantsCreateType } from '@/types/events/participants-create.ts';

export default function participantsCreate(data: ParticipantsCreateType): void {
  const conversationsStore = useConversationsStore();

  conversationsStore.updateOrInsertConversation(data.conversationData);

  if ((conversationsStore.activeConversation as ConversationType)?.conversationId === data.conversationId) {
    conversationsStore.updateActiveConversation(data.conversationData);
  }
}
